/**
 * Creates a default label for an animal using name, ear number (with fallbacks), and breed.
 * @param {Object} animal - Animal object (ZivalAggregateView or similar)
 * @param {string} [animal.ime] - Animal name
 * @param {string} [animal.usesnaStevilka] - Ear number (primary identifier)
 * @param {string} [animal.rodovniskaStevilka] - Genealogical number (fallback 1)
 * @param {string} [animal.zacasnaStevilka] - Temporary number (fallback 2)
 * @param {string} [animal.id] - Animal ID (fallback 3)
 * @param {string} [animal.priznanaPasmaNaziv] - Recognized breed name
 * @returns {string} Formatted label
 */
export const defaultAnimalLabel = (animal) => {
  const identifier =
    animal.usesnaStevilka ||
    animal.rodovniskaStevilka ||
    animal.zacasnaStevilka ||
    animal.id;

  return [animal.ime, identifier, animal.priznanaPasmaNaziv]
    .filter(Boolean)
    .join(" - ");
};
